module.exports = __webpack_public_path__ + "static/media/wall-dontoi.4e59ad6e.png";